import styled from 'styled-components';

export const customStyles = `
  overflow: scroll;
  height: 40%,
  max-height: 40% !important;
  width: 60%;
  position: fixed;
  margin-left: 20%;
  margin-top: 4.5%;
  top: 0;
  left: 0;
  background-color: white;`;

export const ModalFieldLabel = styled.div`
  font-size: 1rem;
  margin-bottom: 4px;
  margin-top: 10px;
`;

export const FieldLabel = styled.div`
  font-size: 1rem;
  margin-bottom: 4px;
  margin-top: 10px;
  font-weight: bold;
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const Td = styled.td`
  border: 1px solid #e3e3e3;
  text-align: center;
  vertical-align: middle;
`;

export const TdLabel = styled.td`
  border: 1px solid #e3e3e3;
  text-align: right;
  vertical-align: middle;
  font-weight: 700;
  padding-right: 100px;
`;

export const Tr = styled.tr`
  border: 1px solid #e3e3e3;
`;

export const Th = styled.th`
  padding-top: 10px;
  text-align: center;
  background: #4b286d;
  color: #fff;
  & * { color: #fff !important; }
`;

export const Table = styled.table`
  margin-bottom: 10px;
`;

export const TdImp = styled.td`
  border: 1px solid #e3e3e3;
  text-align: center;
  background: #f7f7f7;
  font-weight: 700;
  vertical-align: middle;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const StyledCheckbox = styled.input`
  margin-right: 8px;
  transform: scale(1.5);
`;

export const CheckboxText = styled.span`
  font-weight: bold;
  font-size: larger;
`;